import useSWR from "swr";
const fetcher = async (path) => {
    const res = await fetch(path);
    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(`${res.status} ${res.statusText}${text ? ` — ${text}` : ""}`);
    }
    return res.json();
};
export function useApi(path) {
    const { data, error, isLoading } = useSWR(path, fetcher, {
        revalidateOnFocus: false,
        dedupingInterval: 30_000,
    });
    return { data, error, isLoading };
}
